import React, { useState } from 'react';
import { downloadNodeAsPdf, printNode } from '../utils/reportPdfUtils';

export default function ReportActions({ reportRef, studentName, onBack }) {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    if (isGenerating || !reportRef.current) return;
    setIsGenerating(true);
    setError(null);
    try {
      await downloadNodeAsPdf(reportRef.current, studentName);
    } catch (err) {
      console.error('[ReportActions] PDF failed:', err);
      setError('PDF generation failed. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handlePrint = () => {
    if (!reportRef.current) return;
    printNode(reportRef.current);
  };

  return (
    <div className="report-action-header no-print">
      <button
        type="button"
        className="btn btn-secondary"
        onClick={onBack}
        disabled={isGenerating}
      >
        ← Back to Matrix
      </button>

      <div className="action-right-group">
        {error && (
          <span className="report-action-error" role="alert">
            ⚠️ {error}
          </span>
        )}

        <button
          type="button"
          className="btn btn-download"
          onClick={handleDownload}
          disabled={isGenerating}
          aria-busy={isGenerating}
        >
          {isGenerating ? '⏳ Generating…' : '⬇️ Download PDF'}
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handlePrint}
          disabled={isGenerating}
        >
          🖨️ Print
        </button>
      </div>
    </div>
  );
}